import api from "./api";

const PostService = {
    getPromotions: async (page = 0, size = 9, category = '') => {
        try {
            return await api.get("/api/posts", {
                params: { page, size, category, titleCategory: 'PROMOTION' }
            });
        } catch (error) {
            throw error;
        }
    },

    getBlogs: async (page = 0, size = 9, category = '') => {
        try {
            return await api.get("/api/posts", {
                params: { page, size, category, titleCategory: 'BLOG' }
            });
        } catch (error) {
            throw error;
        }
    },

    getByIdOrSlug: async (idOrSlug) => {
        try {
            return await api.get(`/api/posts/${idOrSlug}`);
        } catch (error) {
            throw error;
        }
    }
};

export default PostService;
